<section class="flex h-full w-full rounded-full">
  <article class="relative">
    <input
      type="checkbox"
      name="themeSwitcher"
      id="themeSwitcher"
      class="hidden"
      [checked]="isDark"
      (click)="onChange(true)"
    />
    <label for="themeSwitcher" class="relative cursor-pointer">
      <div class="flex h-8 w-16 items-center rounded-full bg-gray-300">
        <fa-icon
          [icon]="faSun"
          [class.light]="!isDark"
          class="absolute left-2 z-10 p-0"
          size="sm"
        ></fa-icon>
        <div
          class="switchball absolute left-3 h-8 w-8 rounded-full bg-white shadow"
        ></div>
        <fa-icon
          [icon]="faMoon"
          [class.dark]="isDark"
          class="absolute right-2 z-10 p-1"
          size="sm"
        ></fa-icon>
      </div>
    </label>
  </article>
</section>
